@if(data().html){   
    <p [innerHTML]="translatedText()" [ngClass]="data().classes"></p>
}@else {
    <p  [ngClass]="data().classes">{{ translatedText() }}</p>
}